const GUEST_CART_KEY = 'valley_guest_cart';

export const getGuestCart = () => {
  try {
    const cart = JSON.parse(localStorage.getItem(GUEST_CART_KEY) || '[]');
    return Array.isArray(cart) ? cart : [];
  } catch {
    return [];
  }
};

export const addToGuestCart = (item) => {
  const cart = getGuestCart();
  const productId = parseInt(item.idproducts, 10);
  const existingItem = cart.find(cartItem => cartItem.idproducts === productId);

  if (existingItem) {
    const nextQuantity = existingItem.quantity + (parseInt(item.quantity, 10) || 1);
    existingItem.quantity = nextQuantity;
  } else {
    cart.push({
      ...item,
      idproducts: productId,
      quantity: parseInt(item.quantity, 10) || 1,
    });
  }

  localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cart));
  window.dispatchEvent(new Event('cartUpdated'));
  return cart;
};

export const removeFromGuestCart = (productId) => {
  const id = parseInt(productId, 10);
  const cart = getGuestCart().filter(item => item.idproducts !== id);
  localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cart));
  window.dispatchEvent(new Event('cartUpdated'));
  return cart;
};

// Remove a batch of items at once (e.g. the ones that were successfully
// migrated into a logged-in user's server-side cart). Items not in
// productIds are left untouched so a partial migration failure can be
// retried later without re-sending the items that already succeeded.
export const removeManyFromGuestCart = (productIds) => {
  const idSet = new Set(productIds.map(id => parseInt(id, 10)));
  const cart = getGuestCart().filter(item => !idSet.has(item.idproducts));
  localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cart));
  window.dispatchEvent(new Event('cartUpdated'));
  return cart;
};

export const clearGuestCart = () => {
  localStorage.removeItem(GUEST_CART_KEY);
  window.dispatchEvent(new Event('cartUpdated'));
};
